import React, { useState } from "react";
import {
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Grid,
  TextField,
  MenuItem,
} from "@mui/material";
import { FeatureResponse } from "../../../services/models";

interface ListClassFeaturesProps {
  classes: string[];
  classFeatures: FeatureResponse[];
  fetchClassFeatures: (classId: string) => void;
}

const ListClassFeatures: React.FC<ListClassFeaturesProps> = ({
  classes,
  classFeatures,
  fetchClassFeatures,
}) => {
  const [selectedClassId, setSelectedClassId] = useState("");

  const handleClassChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const classId = event.target.value;
    setSelectedClassId(classId);
    fetchClassFeatures(classId);
  };

  return (
    <Grid item xs={12}>
      <Typography variant="h6">View Class Features</Typography>
      <TextField
        select
        label="Class ID"
        value={selectedClassId}
        onChange={handleClassChange}
        fullWidth
      >
        {classes.map((classId) => (
          <MenuItem key={classId} value={classId}>
            {classId}
          </MenuItem>
        ))}
      </TextField>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => fetchClassFeatures(selectedClassId)}
      >
        Fetch Class Features
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Feature Name</TableCell>
              <TableCell>Valid Until</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {classFeatures.map((feature) => (
              <TableRow key={feature.featureName}>
                <TableCell>{feature.featureName}</TableCell>
                <TableCell>
                  {feature.validUntil
                    ? new Date(feature.validUntil).toLocaleString()
                    : "Always"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default ListClassFeatures;
